import { Pipe, PipeTransform } from '@angular/core';
import { RestService } from '../services/rest.service';

@Pipe({
  name: 'itemName'
})
export class ItemNamePipe implements PipeTransform {

  rest:RestService;

  constructor(rest:RestService)
  {
    this.rest = rest;
  }
  transform(value: any ):string
  {
	  if( !value.item )
		  return '';

      if( value.category && this.rest.local_preferences.display_categories_on_items == 'YES' )
      {
        return value.category.name+' - '+value.item.name;
      }

      return value.item.name;
  }

}
